<!--创建-->
<template>
  <div class="create-box-index cr">
    <div class="flex jb">
      <div class="left-create-box" :style="{ backgroundColor: theme.layout1 }">
        <div class="part1-box">
          <div class="select-box" :style="{ backgroundColor: theme.layout1 }">
            <div class="flex ac jb cr">
              <div class="flex ac">

                <div class="pp1" :style="{ color: titleState==2 ? theme.homeColor1 : theme.homeColor2}"
                     @click="handleChoose1(2)">我的形象
                </div>
                <div class="pp1" :style="{ color: titleState==1 ? theme.homeColor1 : theme.homeColor2}"
                     @click="handleChoose1(1)">公共形象
                </div>
                <div class="pp1" :style="{ color: titleState==3 ? theme.homeColor1 : theme.homeColor2}"
                     @click="handleChoose1(3)">素材库
                </div>
              </div>
              <div class="hs-box flex ac" v-if="titleState==1" :style="{ backgroundColor: theme.homeColor6 }">
                <div class="normal"
                     :style="{ color: hsState==1? theme.homeColor3 : theme.homeColor4, backgroundColor: hsState==1 ? theme.homeColor5 : theme.homeColor6}"
                     @click="handleHs(1)">横版
                </div>
                <div class="normal"
                     :style="{ color: hsState==2? theme.homeColor3 : theme.homeColor4, backgroundColor: hsState==2 ? theme.homeColor5 : theme.homeColor6}"
                     @click="handleHs(2)">竖版
                </div>
              </div>
            </div>
          </div>
          <div v-if="titleState==1" class="flex ac cr fw all-video-y">
            <div v-for="(item,index) in videoArray" :key="index" class="all-every-me-fs" v-if="hsState==2">
              <div class="every-me-fs" :class="chooseVideoId==item.id?'actived':''"
                   :style="{backgroundImage: 'url(' + item.cover + ')', backgroundRepeat:'no-repeat'}"
                   @click="handleChooseVideo(item)">
              </div>
              <p class="tc te every-me-text">{{item.name}}</p>
            </div>
            <div v-for="(item,index) in videoArray" :key="index" class="all-every-me-fs-h" v-if="hsState==1">
              <div class="every-me-fs-h" :class="chooseVideoId==item.id?'actived-h':''"
                   :style="{backgroundImage: 'url(' + item.cover + ')', backgroundRepeat:'no-repeat'}"
                   @click="handleChooseVideo(item)">
              </div>
              <p class="tc te every-me-text-h">{{item.name}}</p>
            </div>
          </div>
          <div v-if="titleState==2" class="flex ac cr fw all-video-y">
            <div class="all-every-me-fs" v-if="myVideoArray.length<=0" @click="handleGoUrl('/profile')">
              <div class="every-me-fs fs-border flex ac jc colu">
                <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/4.2_Icon_Upload.png" alt="add">
                <p :style="{ color: theme.homeColor8 }">创建专属形象</p>
              </div>
              <p class="tc te every-me-text"></p>
            </div>
            <div v-for="(item,index) in myVideoArray" :key="index" class="all-every-me-fs">
              <div class="every-me-fs" :class="chooseVideoId==item.id?'actived':''"
                   :style="{backgroundImage: 'url(' + item.cover + ')', backgroundRepeat:'no-repeat'}"
                   @click="handleChooseVideo(item)">
              </div>
              <p class="tc te every-me-text">{{item.name}}</p>
            </div>
          </div>
          <div v-if="titleState==3" class="flex ac cr fw all-video-y">
            <div v-for="(item,index) in scArray" :key="index" class="all-every-me-fs">
              <div class="every-me-fs" :class="chooseVideoId==item.id?'actived':''"
                   :style="{backgroundImage: 'url(' + item.cover + ')', backgroundRepeat:'no-repeat'}"
                   @click="handleChooseVideo(item)">
              </div>
              <p class="tc te every-me-text">{{item.name}}</p>
            </div>
          </div>
        </div>
        <!--    音频参数调节    -->
        <div class="voice-tj-box cr" :style="{ borderBottomColor: theme.layout6,borderTopColor: theme.layout6 }">
          <div class="flex ac jb">
            <p class="text1" :style="{color: theme.createColor1}">音频参数调节</p>
            <div class="flex ac ">
              <div class="flex ac jc btn11 mr05" @click="handleQrxg"
                   :style="{ backgroundColor: theme.createColor2,color: theme.createColor3 }">
                <i class="el-icon-check mr05 fs14"></i>
                <p>确认修改</p>
              </div>
              <div class="flex ac jc btn22" @click="handleHhmr"
                   :style="{ backgroundColor: theme.createColor2,color: theme.createColor3 }">
                <img :src="theme.createIcon1" alt="">
                <p>恢复默认</p>
              </div>
            </div>
          </div>
          <div class="shezhi-box" :style="{ backgroundColor: theme.createColor4,color: theme.createColor1 }">
            <div class="flex ac part-slider">
              <span class="mr20">语速</span>
              <el-slider :disabled="placeholderApi=='nw'" style="width: 85%" v-model="rate" :step="0.1" :min="0.5"
                         :max="2"
                         :format-tooltip="formatTooltip"></el-slider>
            </div>
            <div class="flex ac part-slider">
              <span class="mr20">音量</span>
              <el-slider :disabled="placeholderApi=='fish'||placeholderApi=='nw'" style="width: 85%" v-model="volume"
                         :step="0.1" :min="0.1" :max="3"
                         :format-tooltip="formatTooltip"></el-slider>
            </div>
            <div class="flex ac part-slider">
              <span class="mr20">语调</span>
              <el-slider :disabled="placeholderApi=='fish'||placeholderApi=='nw'" style="width: 85%" v-model="pitch"
                         :step="0.1" :min="0.1" :max="2"
                         :format-tooltip="formatTooltip"></el-slider>
            </div>
          </div>
        </div>
        <!-- 音频选择-->
        <div class="all-voice-choose-box cr bbox">
          <div class="flex ac cr mb15">
            <div v-for="(item,index) in tabsList" :key="index" class="every-tab" @click="handleTab(item)"
                 :style="{ color: item.id == tabId? theme.homeColor1 : theme.homeColor2}">
              <p>{{item.name}}</p>
            </div>
          </div>
          <div v-if="tabId==0" class="voice-choose-box">
            <div class="flex ac jb fw">
              <div class="every-voice flex ac" v-for="(item,index) in voiceArray" :key="index"
                   :style="{ backgroundColor: theme.layout1, borderColor:theme.homeColor7 }"
                   :class="chooseVoiceId==item.id?'active': ''" @click="handleChooseVoice(item)">
                <div class="card-img" @mouseover="handleMouse2(item)" @mouseleave="handleMouseOut2"
                     @click="handlePlay2(item)">
                  <img src="../assets/pcImages/1.3_Icon1@2x.png" alt="">
                  <div class="hover-box icon-player playing" v-if="mouseState && hoverId==item.id">
                    <div class="play-pause-btn">
                      <i class="el-icon-video-play" v-if="palyState==1 || clickId!=item.id"
                         style="color: #ffffff;font-size: 25px"></i>
                      <i class="el-icon-video-pause" v-if="palyState==2" style="color: #ffffff;font-size: 25px"></i>
                      <img class="playing-box" v-if="palyState==3 && clickId==item.id"
                           src="../assets/pcImages/voice-playing.gif">
                    </div>
                  </div>
                </div>
                <div>
                  <p class="pp4 te" :style="{ color: theme.homeColor8 }">{{item.name}}</p>
                  <p class="pp5" :style="{ color: theme.homeColor9 }">
                    {{site_title}}{{item.version_name}}音频</p>
                </div>
              </div>
            </div>

          </div>
          <div v-if="tabId==1" class="voice-choose-box">
            <div class="flex ac jb fw">
              <div class="every-voice flex ac" v-if="myVoiceArray.length<=0" @click="handleGoUrl('/clone')"
                   :style="{ backgroundColor: theme.layout1, borderColor:theme.homeColor7 }">
                <div class="card-img">
                  <img src="https://xcyq.oss-cn-qingdao.aliyuncs.com/html/base/images/home/up3.svg" alt="1">
                </div>
                <div>
                  <p class="pp4 te" :style="{ color: theme.homeColor8 }">克隆您的专属声音</p>
                  <p class="pp5" :style="{ color: theme.homeColor9 }">
                    去克隆</p>
                </div>
              </div>


              <div class="every-voice flex ac" v-for="(item,index) in myVoiceArray" :key="index"
                   :style="{ backgroundColor: theme.layout1, borderColor:theme.homeColor7 }"
                   :class="chooseVoiceId==item.id?'active': ''" @click="handleChooseVoice(item)">
                <div class="card-img" @mouseover="handleMouse2(item)" @mouseleave="handleMouseOut2"
                     @click="handlePlay2(item)">
                  <img src="../assets/pcImages/1.3_Icon1@2x.png" alt="">
                  <div class="hover-box icon-player playing" v-if="mouseState && hoverId==item.id">
                    <div class="play-pause-btn">
                      <i class="el-icon-video-play" v-if="palyState==1 || clickId!=item.id"
                         style="color: #ffffff;font-size: 25px"></i>
                      <i class="el-icon-video-pause" v-if="palyState==2" style="color: #ffffff;font-size: 25px"></i>
                      <img class="playing-box" v-if="palyState==3 && clickId==item.id"
                           src="../assets/pcImages/voice-playing.gif">
                    </div>
                  </div>
                </div>
                <div>
                  <p class="pp4 te" :style="{ color: theme.homeColor8 }">{{item.name}}</p>
                  <p class="pp5" :style="{ color: theme.homeColor9 }">
                    {{site_title}}{{item.version_name}}音频</p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tabId==2" class="voice-choose-box">
            <div class="flex ac jb fw">
              <div class="every-voice flex ac" v-for="(item,index) in voiceScArray" :key="index"
                   :style="{ backgroundColor: theme.layout1, borderColor:theme.homeColor7 }"
                   :class="chooseVoiceId==item.id?'active': ''" @click="handleChooseVoice2(item)">
                <div class="card-img" @mouseover="handleMouse2(item)" @mouseleave="handleMouseOut2"
                     @click="handlePlay2(item)">
                  <img src="../assets/pcImages/1.3_Icon1@2x.png" alt="">
                  <div class="hover-box icon-player playing" v-if="mouseState && hoverId==item.id">
                    <div class="play-pause-btn">
                      <i class="el-icon-video-play" v-if="palyState==1 || clickId!=item.id"
                         style="color: #ffffff;font-size: 25px"></i>
                      <i class="el-icon-video-pause" v-if="palyState==2" style="color: #ffffff;font-size: 25px"></i>
                      <img class="playing-box" v-if="palyState==3 && clickId==item.id"
                           src="../assets/pcImages/voice-playing.gif">
                    </div>
                  </div>
                </div>
                <div>
                  <p class="pp4 te" :style="{ color: theme.homeColor8 }">{{item.name}}</p>
                  <p class="pp5" :style="{ color: theme.homeColor9 }">
                    {{item.source=='analyse'?'音频提取': ''}}--音频</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="right-create-box">
        <div class="name-box flex ac">
          <div style="width: 240px" v-if="inputState">
            <el-input
              ref="inputRef"
              @blur="handleBlur"
              placeholder="请输入作品名称"
              v-model="name"
              clearable>
            </el-input>
          </div>
          <p class="pp2 cr" @click="showInput" v-if="!inputState">{{textName}}</p>
          <i class="el-icon-edit-outline cr ml05" @click="showInput"></i>
        </div>
        <!--   选择的视频     -->
        <div class="video-show-box"
             :style="{backgroundImage: 'url(' + theme.createIcon2 + ')', backgroundRepeat:'no-repeat'}">
          <div class="part-video">
            <video ref="videoPlayer" controls="" :autoplay="false"
                   style="width: 100%;height: 100%;object-fit: contain"
                   :src="chooseVideoUrl"></video>
          </div>
        </div>
        <div class="choose-box flex ac cr" :style="{ backgroundColor: theme.createColor10 }">
          <div class="wb-text-box flex ac jc" :class="choosed==1?'active': ''"
               :style="{ color: choosed==1? theme.createColor5 : theme.createColor6, backgroundColor: choosed==1 ? theme.homeColor5 : ''}"
               @click="handleChoosed(1)">
            <img v-if="choosed==1" :src="theme.createIcon3" alt="">
            <img v-else :src="theme.createIcon4" alt="">
            <p>文本驱动</p>
          </div>
          <div class="yp-text-box flex ac jc" :class="choosed==2?'active': ''"
               :style="{ color: choosed==2? theme.createColor5 : theme.createColor6, backgroundColor: choosed==2 ? theme.homeColor5 : ''}"
               @click="handleChoosed(2)">
            <img v-if="choosed==2" :src="theme.createIcon5" alt="">
            <img v-else :src="theme.createIcon6" alt="">
            <p>音频驱动</p></div>
        </div>
        <div v-if="choosed==1">
          <div class="taici-box">
            <div class="mt15 bbox" :class="theme.id==2?'inputText2': 'inputText1'">
              <editable-div class="editBox bbox" v-model="inputTaici"
                            @changeText="(value)=>bindDateChange(value)"
              ></editable-div>
            </div>

            <div v-if="voiceApi=='nw' || voiceApi=='hs'|| voiceApi=='mm'|| voiceApi=='kyy' "
                 class="nw-voice-box flex ac jb"
                 :class="theme.id==2?'editBox2-tips': 'editBox-tips'">
              <div class="flex ac">
                <span class="mr05">选择语种:(不选默认文本输入语种)</span>
                <el-cascader :options="regionData" :props="propObj" size="mini" v-model="languageId"
                             placeholder="请选择语种" clearable @visible-change="handleChangeLanguage"></el-cascader>
                <!--选择情绪-->
                <div v-if="voiceApi=='mm' || voiceApi=='kyy'" class="ml10">
                  <span>选择音频情绪：</span>
                  <el-select v-model="emotionId" placeholder="请选择" size="mini" @change="handleEmotion">
                    <el-option
                      v-for="item in emotionList"
                      :key="item.id"
                      :label="item.cateName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div v-if="voiceApi=='nw'">{{handleTj(taici)}}/500</div>
              <div v-else>{{handleTj(taici)}}/10000</div>
            </div>
            <div v-else class="flex ac jb" :class="theme.id==2?'editBox2-tips': 'editBox-tips'">
              <div class="mr30 fs13">*{{language}}</div>
              <div>{{handleTj(taici)}}/10000</div>
            </div>
            <div class="flex ac mt15 cr">
              <div class="st-part flex ac jc mr10" v-if="shitingplayState==1" @click="handleShiTing(1)"
                   :style="{ borderColor: theme.homeColor7,color: theme.homeColor8}">
                <img :src="theme.createIcon7" alt="">
                <p>试听</p>
              </div>
              <div class="st-part flex ac jc mr10" v-if="shitingplayState==2" @click="handleShiTing(2)"
                   :style="{ borderColor: theme.homeColor7,color: theme.homeColor8}">
                <img :src="theme.createIcon10" alt="" style="width: 12px;height: 12px;margin-right: 5px">
                <p>试听中</p>
              </div>

              <el-popover
                aria-hidden="true"
                placement="top"
                v-model="visible"
                trigger="manual">
                <div>
                  <el-button size="mini" @click.stop="insertImg({name:'停顿0.2s',code:0.2})">停顿0.2s</el-button>
                  <el-button size="mini" @click.stop="insertImg({name:'停顿0.3s',code:0.3})">停顿0.3s</el-button>
                  <el-button size="mini" @click.stop="insertImg({name:'停顿0.5s',code:0.5})">停顿0.5s</el-button>
                  <el-button size="mini" @click.stop="insertImg({name:'停顿1s',code:1})">停顿1s</el-button>
                  <el-button size="mini" @click.stop="insertImg({name:'停顿2s',code:2})">停顿2s</el-button>
                </div>
                <el-button v-if="theme.id==1&&placeholderApi!='fish'&&placeholderApi!='nw'" size="mini"
                           style="background: rgba(255, 255, 255, 0.1);border: none;color: #ffffff;padding: 7px 10px;margin-right: 10px"
                           slot="reference"
                           icon="el-icon-s-fold" @click="visible = !visible">插入停顿
                </el-button>
                <el-button v-if="theme.id==2&&placeholderApi!='fish'&&placeholderApi!='nw'" size="mini"
                           style="background: rgba(255, 255, 255, 0.1);color: #333333;padding: 7px 10px;margin-right: 10px"
                           slot="reference"
                           icon="el-icon-s-fold" @click="visible = !visible">插入停顿
                </el-button>
              </el-popover>

              <div class="st-part flex ac jc mr10" @click="handleRunse"
                   :style="{ borderColor: theme.homeColor7,color: theme.homeColor8}">
                <img :src="theme.createIcon9" alt="">
                <p>文案润色</p>
              </div>
              <div class="st-part flex ac jc mr10" @click="handleBangxie"
                   :style="{ borderColor: theme.homeColor7,color: theme.homeColor8}">
                <img :src="theme.createIcon8" alt="">
                <p>AI帮写</p>
              </div>
              <div class="st-part flex ac jc" @click="handleYqfh"
                   :style="{ borderColor: theme.homeColor7,color: theme.homeColor8}">
                <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/yqfh_icon.png" alt="">
                <p>语气符号</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="choosed==2">
          <div class="warning" :style="{ backgroundColor: theme.homeColor6 ,color:theme.createColor6}">
            <p class="pp4">音频要求</p>
            <div class="flex ac">
              <p class="pp5">文件格式：<span>mp3、m4a、wav</span></p>
              <p class="pp5">音频时长：<span>5秒～30分钟</span></p>
            </div>

          </div>
          <div class="upload-box mt20" v-if="fileList.length<=0">
            <div class="upload-box1" v-if="theme.id==1">
              <el-upload
                ref="upload"
                drag
                action="https://g.xingchaoyiqing.com/api/upload/voice"
                accept=".mp3,.wav,.m4a,.MP3,.WAV,.M4A"
                :on-progress="handleUping"
                :on-success="handleFileUpSuccess"
                :on-error="handleFileUpError"
                :on-remove="handleRemove"
                multiple
                :limit="1"
                :headers="myHeaders"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">请上传一段音频，用于声音克隆</div>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
            </div>
            <div class="upload-box2" v-if="theme.id==2">
              <el-upload
                ref="upload"
                drag
                action="https://g.xingchaoyiqing.com/api/upload/voice"
                accept=".mp3,.wav,.m4a,.MP3,.WAV,.M4A"
                :on-progress="handleUping"
                :on-success="handleFileUpSuccess"
                :on-error="handleFileUpError"
                :on-remove="handleRemove"
                multiple
                :limit="1"
                :headers="myHeaders"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">请上传一段音频，用于声音克隆</div>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
            </div>

          </div>
          <div class="upload-wanchen-box flex ac jc" v-else>
            <audio
              ref="audioPlayer"
              :src="fileList[0].url"
              controls></audio>
            <el-button type="warning" size="mini" style="margin-left: 20px" @click="handleReUplod">重新上传</el-button>
          </div>
        </div>
        <div class="btn-box">
          <div class="flex ac jfe">
            <div class="btn2" @click="handleJLCreate('')">合成视频</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="AI帮写"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <div class="all-js-box">
        <div class="fs16 bold mb10">主题选择</div>
        <div class="scroll-box">
          <div class="flex ac fw" style="width: 100%;">
            <div class="erery-js fs14" v-for="(item,index) in jsList" :key="index"
                 :class="choosedIndex==index?'active': ''" @click="handleChoose(index)">
              <div class="">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="part1-box flex ac jb">
        <div class="fs16 bold mb10 mt10">主题描述</div>
        <div class="pp-fw" @click="handleTry">试试范文</div>
      </div>
      <div class="part2-box bbox">
        <el-input
          ref="textarea2"
          style="flex: 1"
          type="textarea"
          :autosize="{ minRows: 7, maxRows: 7}"
          placeholder="例如:本地生活(可选主题后试试范文,随机生成)"
          v-model="message"
          maxlength="500"
          show-word-limit
        >
        </el-input>
      </div>
      <div class="part3-box">
        <div class="fs16 bold mt10 mb10">字数要求</div>
        <el-select v-model="selectValue" placeholder="请选择">
          <el-option
            v-for="item in selectList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="handleStartBx">开始AI帮写</el-button>
  </span>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisible2"
      :width="videoChannelList.length>=4 ? '56%' :videoChannelList.length==3? '45%' : videoChannelList.length==2 ? '33%' : '20%'"
      top="30vh"
    >
      <span slot="title">
        <span style="color: #222222" class="fs18 bold">选择AI视频训练方式</span>
        <span style="color: #C6702D;"
              class="fs14"> {{videoChannelTips ? videoChannelTips : '(效果差别：3.0深度>2.0极速>1.0免费)'}} </span>
      </span>
      <div class="ai-choose-box flex ac fw jc">
        <div v-for="(item,index) in videoChannelList" :key="index" class="ai-part1-box"
             @click="goCreate(item.api,item.name)">
          <div class="aipp1">{{item.name}}</div>
          <div class="aipp2">{{item.desc}}</div>
          <div v-if="item.version_name" class="aipp3">{{item.version_name}}</div>
          <div v-if="item.credits>0" class="aipp4 flex ac jc">
            <img src="../assets/pcImages/Icon_Points@2x.png" alt="">
            <div>{{item.credits}}积分/秒</div>
          </div>
          <div v-else class="no-credits-text"></div>
          <div class="aibtn1">去合成></div>
        </div>
      </div>
    </el-dialog>


    <audio
      style="width: 1px;height: 1px;opacity: 0;position: fixed;right: 0;bottom: 0"
      ref="audioPlayer2"
      :src="audioSrc"
      @ended="handleEnded"
      controls></audio>
  </div>
</template>
<script>
  import {
    getVideo,
    getVoice,
    postWorks,
    postAudition,
    getAudition,
    voiceEdit,
    timeout,
    textpolish,
    postchat,
    gtheme, delVoice, site,
    getIndexVideo,
    gVideoChannel,
    gvoiceChannel,
    gLangList, getMaterial, postTranslate
  } from '../api/user'
  import _ from 'lodash';
  import {throttle} from "../../utils";
  import router from "../router";
  import EditableDiv from './EditableDiv.vue'; // 引入上面创建的可编辑组件

  export default {
    name: '',
    components: {
      EditableDiv,
    },
    computed: {
      myHeaders() {
        return {'x-token': window.localStorage.getItem('xcToken') || ''}
      },
      theme() {
        // 1是黑色
        return this.$store.getters.getTheme;
      }
    },
    data() {
      return {
        name: '',
        inputState: false,
        textName: '未命名',
        choosed: '1',
        taici: '',
        // 语言翻译的来源
        source2: '',
        //提示文案
        language: '请在上方输入您的台词！选择音频后可知该音频支持哪些国家的语言!',
        inputTaici: '',
        dingyi: '',
        activeName: 'first',
        tdList: [
          {
            name: '停顿0.2s',
            seconds: '0.2'
          },
          {
            name: '停顿0.3s',
            seconds: '0.3'
          },
          {
            name: '停顿0.5s',
            seconds: '0.5'
          },
          {
            name: '停顿1s',
            seconds: '1'
          },
          {
            name: '停顿2s',
            seconds: '2'
          }
        ],
        videoArray: [],
        myVideoArray: [],
        scArray: [],
        myVoiceArray: [],
        voiceArray: [],
        voiceScArray: [],
        chooseVideoId: null,
        chooseVideoUrl: '',
        tabsList: [
          {id: 1, name: '我的'},
          {id: 0, name: '公共'},
          {id: 2, name: '素材库'},
        ],
        tabId: 1,
        chooseVoiceId: null,
        audioSrc: '',
        voiceId: '',
        fileList: [],
        loading: '',
        voice_id: '',
        video_id: '',
        sucessVoiceUrl22: '',
        file_id22: '',
        job_id: '',
        timeoutId: null,
        equal: true,
        // 选中试听文本
        selectedText: '',
        selectionStart: '',
        selectionEnd: '',
        rate: 1,
        volume: 1,
        pitch: 1,
        api: '',
        video_channel_name: '',
        dialogVisible2: false,

        titleState: 2,
        hsState: 1,

        mouseState: false,
        palyState: 1,
        clickId: false,

        dialogVisible: false,
        message: '',
        jsList: [],
        ztList: [],
        choosedIndex: 0,
        themeObj: {},
        show: false,
        selectList: [{
          value: '0',
          label: '不限字数'
        },
          {
            value: '150',
            label: '约150字≈30s'
          },
          {
            value: '300',
            label: '约300字≈60s'
          },
          {
            value: '500',
            label: '约500字≈120s'
          }
        ],
        selectObj: {
          value: '0',
          label: '不限字数'
        },
        selectValue: '0',
        site_title: '',
        shitingplayState: 1,
        placeholderApi: null,
        videoChannelList: [],
        videoChannelTips: '',
        videoDuration: 0,

        visible: false,

        // 声音的api
        voiceApi: '',
        regionData: [],
        propObj: {
          label: 'name',
          children: 'list',
          value: 'language',
          checkStrictly: true // 允许选择任意一级节点
        },
        languageId: [],
        // 选中的素材的来源
        source: '',
        // 音频来源
        audio_source: '',

        emotionList: [{
          cateName: '默认',
          id: ''
        },
          {
            cateName: '高兴',
            id: 'happy'
          },
          {
            cateName: '悲伤',
            id: 'sad'
          },
          {
            cateName: '愤怒',
            id: 'angry'
          },
          {
            cateName: '害怕',
            id: 'fearful'
          }, {
            cateName: '厌恶',
            id: 'disgusted'
          }, {
            cateName: '惊讶',
            id: 'surprised'
          }, {
            cateName: '中性',
            id: 'neutral'
          },
        ],
        emotionId: '',
      }
    },
    created() {
      if (this.$route.query.source == 3) {
        this.getScVideoList()
        this.chooseVideoId = this.$route.query.id
        this.titleState = 3
      } else {
        if (this.$route.query.id && !this.$route.query.hs) {
          this.chooseVideoId = this.$route.query.id
          this.titleState = 2
        }
        if (this.$route.query.id && this.$route.query.hs) {
          this.chooseVideoId = this.$route.query.id
          this.titleState = 1
          this.hsState = this.$route.query.hs
        }
      }
      if (this.$route.query.origin == 'audio' && this.$route.query.audioId) {
        this.choosed = 2
        this.tabId = 2
        this.chooseVoiceId = this.$route.query.audioId
        this.getScVoiceList()
      }
      if (this.$route.query.type == 'fk') {
        this.inputTaici = JSON.parse(window.sessionStorage.getItem('createText'))
        this.taici = JSON.parse(window.sessionStorage.getItem('createText'))
      }
      this.getVideoList()
      this.getMyVideoList()
      this.getVoiceList()
      this.getMyVoiceList()
      this.gstTheme()
      this.getSite()
      this.getgVideoChannel()
    },
    methods: {
      // 获取合成文案
      getgVideoChannel() {
        gVideoChannel().then(res => {
          this.videoChannelList = res.data.list
          this.videoChannelTips = res.data.tips
        })
      },
      // 获取配置
      getSite() {
        site().then(res => {
          this.site_title = res.data.site_title ? res.data.site_title : 'AI超级分身'
        })
      },
      handleChoose1(val) {
        this.titleState = val
        val == 3 ? this.getScVideoList() : ''
      },
      handleHs(val) {
        this.hsState = val
        this.getVideoList()
      },
      formatTooltip(val) {
        // return val.toFixed(1);
      },
      showInput() {
        this.inputState = true
        this.$nextTick(() => {
          this.$refs.inputRef.focus();
        })
      },
      handleBlur() {
        this.textName = this.name ? this.name : '未命名'
        this.inputState = false
      },
      handleTab(item) {
        this.tabId = item.id
        item.id == 2 ? this.getScVoiceList() : ''
      },
      handleChoosed(val) {
        if (this.choosed == val) {
          return
        }
        this.choosed = val
        this.inputTaici = this.taici
      },
      handleGoUrl(val) {
        this.$router.push(val)
      },

      handleChooseVoice(item) {
        if (item.generate_status == 1) {
          this.$message.error('声音训练中，暂时无法选择')
          return false
        }
        if (item.generate_status == 3) {
          this.$message.error('声音训练失败，无法选择')
          return false
        }
        this.audio_source = ''
        this.choosed = 1
        this.placeholderApi = item.api
        this.sucessVoiceUrl22 = ''
        this.chooseVoiceId = item.id
        this.rate = item.rate ? item.rate : 1
        this.volume = item.volume ? item.volume : 1
        this.pitch = item.pitch ? item.pitch : 1
        this.voiceApi = item.api ? item.api : ''
        if (item.api != 'xf' || item.api != 'fish') {
          this.getLangList()
        }
        this.getGvoiceChannel(item.api)
      },
      handleChooseVoice2(item) {
        this.audio_source = item.source
        this.chooseVoiceId = item.id
        this.choosed = 2
        this.fileList = []
        this.fileList.push(item)
      },
      // 获取89国语言
      getLangList() {
        this.regionData = []
        gLangList({api: this.voiceApi}).then(res => {
          this.regionData = res.data
        })
      },

      // 获取音频文本提示词
      getGvoiceChannel(val) {
        gvoiceChannel({
          api: val
        }).then(res => {
          this.language = res.data.language ? res.data.language : '请在上方输入您的台词！选择音频后可知该音频支持哪些国家的语言!'
        })
      },
      getVideoList() {
        getIndexVideo({source: '2', page: 1, limit: 9999}).then(res => {
          if (res.data.total <= 0) {
            this.titleState = 2
          }
          if (this.hsState == 1) {
            this.videoArray = res.data.hlist
          } else {
            this.videoArray = res.data.slist
          }
          if (this.chooseVideoId) {
            for (let i = 0; i < res.data.list.length; i++) {
              if (this.chooseVideoId == res.data.list[i].id) {
                this.chooseVideoUrl = res.data.list[i].url
                break
              }
            }
          }
        })
      },
      getMyVideoList() {
        getVideo({source: '1', page: 1, limit: 9999}).then(res => {
          this.myVideoArray = res.data.list
          if (this.chooseVideoId) {
            for (let i = 0; i < this.myVideoArray.length; i++) {
              if (this.chooseVideoId == this.myVideoArray[i].id) {
                this.chooseVideoUrl = this.myVideoArray[i].url
                break
              }
            }
          } else {
            this.chooseVideoId = res.data.list.length > 0 ? res.data.list[0].id : ''
            this.chooseVideoUrl = res.data.list.length > 0 ? res.data.list[0].url : ''
          }
        })
      },
      // 获取素材形象
      getScVideoList() {
        getMaterial({page: 0, limit: 0, type: 'video', source: '0'}).then(res => {
          this.scArray = res.data.list
          if (this.chooseVideoId) {
            for (let i = 0; i < this.scArray.length; i++) {
              if (this.chooseVideoId == this.scArray[i].id) {
                this.source = 'sc'
                this.chooseVideoUrl = this.scArray[i].url
                break
              }
            }
          }
        })
      },
      getMyVoiceList() {
        getVoice({source: '1', page: 1, limit: 9999}).then(res => {
          this.myVoiceArray = res.data.list
        })
      },
      getVoiceList() {
        getVoice({source: '2', page: 1, limit: 9999}).then(res => {
          this.voiceArray = res.data.list
        })
      },
      getScVoiceList() {
        getMaterial({page: 0, limit: 0, type: 'audio', source: '0'}).then(res => {
          this.voiceScArray = res.data.list
          if (this.chooseVoiceId) {
            for (let i = 0; i < this.voiceScArray.length; i++) {
              if (this.chooseVoiceId == this.voiceScArray[i].id) {
                this.audio_source = 'sc'
                this.fileList = []
                this.fileList.push(this.voiceScArray[i])
                break
              }
            }
          }
        })
      },
      handleChooseVideo(item) {
        this.chooseVideoId = item.id
        this.chooseVideoUrl = item.url
        this.source = item.source ? item.source : ''
      },

      handleMouse2(item) {
        this.mouseState = true
        this.hoverId = item.id
      },
      handleMouseOut2() {
        if (this.palyState != 3) {
          this.mouseState = false
        }
      },
      handlePlay2(item) {
        this.mouseState = true
        this.clickId = item.id
        if (this.palyState == 1) {
          this.palyState = 3
          this.audioSrc = item.url
          this.$nextTick(() => {
            const audio = this.$refs.audioPlayer2
            audio.load()
            audio.play()
          })
        } else if (this.palyState == 3) {
          this.palyState = 1
          this.$refs.audioPlayer2.pause()
        }
      },

      audioEnded() {
        this.palyState = 1
      },
      handleReUplod() {
        this.fileList = []
        // 重置上传组件
        this.$refs.upload.clearFiles();
      },
      handleRemove() {
        this.fileList = []
      },
      handleUping() {
        this.loading = this.$loading({
          lock: true,
          text: '上传中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
      },
      handleFileUpSuccess(file) {
        if (file.code == 100) {
          this.loading.close();
          this.$message.error(file.msg)
          const url = window.location.hash.split('#')[1]
          router.replace({
            path: '/login',
            query: {
              redirectUrl: url
            }
          })
          return false
        }
        if (file.data.url && file.data.file_id) {
          this.fileList.push(file.data)
          this.$message.success('上传成功')
          this.loading.close();
        }
      },
      handleFileUpError() {
        this.$message.error('上传失败，请重新上传')
        this.loading.close();
      },
      handleBlur2() {
        this.$nextTick(() => {
          this.$refs.textarea.focus;
        });
      },
      // 插入按钮
      insertImg(pas) {
        let a = `<button contenteditable="false" style="margin: 0 2px;
    border-radius: 5px;color: #EB9600;display: inline-block;background-color: #FDF1E1;
    padding: 2px 5px;font-size: 12px">${pas.name}</button>&nbsp;`
        document.execCommand('insertHTML', true, a)
        this.visible = false;
      },
      bindDateChange(value) {
        this.taici = this.washDate(value);
        this.sucessVoiceUrl22 = '';
        this.file_id22 = '';
      },

      // 处理数据
      washDate(value) {
        if (value) {
          value = value.replace(/&nbsp;/g, '')
          // 正则提取秒数
          const regex = /<button[^>]*>停顿([\d.]+)s<\/button>/g;
          let match;
          let updatedHtml = value;
          // 循环匹配每个<button>标签并替换成<break>标签
          while ((match = regex.exec(value)) !== null) {
            const seconds = match[1]; // 提取秒数
            const breakTag = `<break>${seconds}</break>`; // 用<break>标签封装
            updatedHtml = updatedHtml.replace(match[0], breakTag); // 替换原始<button>标签
          }
          return updatedHtml; // 更新显示内容
        }
      },
      // 去除breake标签
      removeTagsAndCountWords(str) {
        let cleanedStr = str.replace(/<brake>.*?<\/brake>/g, '');
        return cleanedStr;
      },
      removeHtmlTags(str) {
        // 使用正则表达式去除所有 HTML 标签
        return str.replace(/<[^>]*>/g, "");
      },
      handleChangeLanguage(val) {
        if (!val) {
          if (this.voiceApi != 'nw' && this.taici) {
            this.$confirm('此操作将输入框的文本翻译成您选择语种文案, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              postTranslate({'text': this.taici, 'target': this.languageId[0],'source': this.source2}).then(res => {
                this.inputTaici = res.data.text
                this.taici = res.data.text
                this.source2 = res.data.target
              }).catch(error => {
                this.$message.error(error.msg)
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
          }
        }
        this.sucessVoiceUrl22 = ''
      },
      // 选择情绪
      handleEmotion() {
        this.sucessVoiceUrl22 = ''
      },
      //统计字数
      handleTj(value) {
        if (value == '<br>') {
          return 0
        }
        var ziNumber = this.removeTagsAndCountWords(this.removeHtmlTags(value)).length
        return ziNumber
      },
      getSelectedText() {
        const textarea = this.$refs.textarea; // 获取原生textarea DOM元素
        textarea.focus(); // 确保textarea是焦点状态
        const selection = window.getSelection(); // 获取选区对象
        if (selection.toString().length > 0) {
          this.selectedText = selection.toString(); // 获取选中的文本
        } else {
          this.selectedText = ''
        }
      },
      // 选中试听
      selectedShiTing() {
        this.loading = this.$loading({
          lock: true,
          text: '合成中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
        var selectedLanguage = ''
        if (this.languageId.length > 0) {
          if (this.languageId.length == 1) {
            selectedLanguage = this.languageId[0]
          }
          if (this.languageId.length == 2) {
            selectedLanguage = this.languageId[1]
          }
        }
        postAudition({
          language: selectedLanguage,
          emotion: this.emotionId,
          voice_id: this.chooseVoiceId,
          text: this.selectedText,
          rate: this.tabId == 0 ? this.rate : '',
          volume: this.tabId == 0 ? this.volume : '',
          pitch: this.tabId == 0 ? this.pitch : ''
        }).then(res => {
          if (res.data.job_id) {
            this.job_id = res.data.job_id
          }
        }).catch(() => {
          this.loading.close()
          return false
        }).then(() => {
          if (this.job_id) {
            this.timeoutId = null
            this.timeoutId = setInterval(this.getAuditionList3, 3000)
          }
        })
      },
      handleHhmr() {
        voiceEdit({voice_id: this.chooseVoiceId, rate: 1, volume: 1, pitch: 1}).then(res => {
          // this.$message.success(res.msg)
          if (res.msg) {
            this.$message.success(res.msg)
          } else {
            this.$message.success('操作成功！')
          }
          this.sucessVoiceUrl22 = ''
          this.rate = 1
          this.volume = 1
          this.pitch = 1
          this.getVoiceList()
          this.getMyVoiceList()
        })
      },
      handleQrxg() {
        voiceEdit({voice_id: this.chooseVoiceId, rate: this.rate, volume: this.volume, pitch: this.pitch}).then(res => {
          if (res.msg) {
            this.$message.success(res.msg)
          } else {
            this.$message.success('修改成功！')
          }
          this.sucessVoiceUrl22 = ''
          this.getVoiceList()
          this.getMyVoiceList()
        })
      },
      handleRunse() {
        if (this.taici.length <= 0) {
          this.$message.error('请输入文本！')
          return false
        }
        this.$confirm('此操作将改变输入框的文本, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = this.$loading({
            lock: true,
            text: '文案润色中,请等待...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.6)'
          });
          textpolish({text: this.taici}).then(res => {
            this.loading.close();
            this.sucessVoiceUrl22 = ''
            this.inputTaici = res.data.content
            this.taici = res.data.content
          }).catch(error => {
            this.loading.close();
            this.$message.error(error.msg)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      handleYqfh() {
        if (this.taici.length <= 0) {
          this.$message.error('请输入文本！')
          return false
        }
        this.$confirm('此操作将改变输入框的文本, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = this.$loading({
            lock: true,
            text: '文案语气化中,请等待...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.6)'
          });
          textpolish({text: this.taici,action:'emotion'}).then(res => {
            this.loading.close();
            this.sucessVoiceUrl22 = ''
            this.inputTaici = res.data.content
            this.taici = res.data.content
          }).catch(error => {
            this.loading.close();
            this.$message.error(error.msg)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },

      handleBangxie() {
        this.dialogVisible = true
        // this.$message.error('暂未上线，敬请期待')
      },
      gstTheme() {
        gtheme().then(res => {
          this.jsList = res.data
        })
      },
      handleChoose(index) {
        this.choosedIndex = index
        if (this.jsList[this.choosedIndex].list) {
          this.ztList = this.jsList[this.choosedIndex].list
        }
      },
      handleTry() {
        this.themeObj = this.getRandomElement(this.ztList)
        this.message = this.themeObj.name
      },
      getRandomElement(arr) {
        // Math.random() 生成一个0到1之间的随机数，然后乘以数组长度并向下取整，得到一个索引值
        const index = Math.floor(Math.random() * arr.length);
        return arr[index];
      },
      // 确定文案
      handleSumbit() {
        this.loading = this.$loading({
          lock: true,
          text: '文案生成中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
        postchat({
          keyword: this.message,
          length: this.selectValue
        }).then(res => {
          this.loading.close();
          this.$message.success('文案生成成功！')
          this.inputTaici = res.data.content
          this.taici = res.data.content
          this.sucessVoiceUrl22 = ''
          this.dialogVisible = false
        }).catch(error => {
          this.loading.close();
          this.$message.error(error.msg)
        })
      },
      handleStartBx() {
        if (!this.message) {
          this.$message.error('请填写主题描述！')
          return false
        }
        this.$confirm('此操作将改变输入框的文本, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.handleSumbit()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      // 有关文本试听操作开始
      handleShiTing(val) {
        if (val == 1) {
          // this.audioSrc && this.audioSrc
          this.audioSrc && this.$refs.audioPlayer2.pause()
          if (this.taici.length > 0 && this.chooseVoiceId) {
            if (this.selectedText) {
              this.selectedShiTing()
            } else {
              if (this.sucessVoiceUrl22.length <= 0 && this.choosed == 1) {
                this.loading = this.$loading({
                  lock: true,
                  text: '合成中,请等待...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.6)'
                });
                var selectedLanguage = ''
                if (this.languageId.length > 0) {
                  if (this.languageId.length == 1) {
                    selectedLanguage = this.languageId[0]
                  }
                  if (this.languageId.length == 2) {
                    selectedLanguage = this.languageId[1]
                  }
                }
                postAudition({
                  language: selectedLanguage,
                  emotion: this.emotionId,
                  voice_id: this.chooseVoiceId, text: this.taici,
                  rate: this.tabId == 0 ? this.rate : '',
                  volume: this.tabId == 0 ? this.volume : '',
                  pitch: this.tabId == 0 ? this.pitch : ''
                }).then(res => {
                  if (res.data.job_id) {
                    this.job_id = res.data.job_id
                  }
                }).catch(() => {
                  this.loading.close()
                  return false
                }).then(() => {
                  if (this.job_id) {
                    this.timeoutId = null
                    this.timeoutId = setInterval(this.getAuditionList, 3000)
                  }
                })
              } else {
                this.audioSrc = this.sucessVoiceUrl22
                this.shitingplayState = 2
                this.$nextTick(() => {
                  const audio = this.$refs.audioPlayer2
                  audio.load()
                  audio.play()
                })
              }
            }
          } else {
            this.$message.error('请输入试听文本和选择数字声音')
          }
        } else if (val == 2) {
          this.shitingplayState = 1
          this.audioSrc && this.$refs.audioPlayer2.pause()
        }
      },
      handleEnded() {
        // 当音频播放完成时，更新状态
        this.shitingplayState = 1;
      },
      // 试听版
      getAuditionList() {
        getAudition({job_id: this.job_id}).then(res => {
          if (res.data.status == 3) {
            if (this.timeoutId) {
              clearInterval(this.timeoutId)
            }
            this.sucessVoiceUrl22 = res.data.url
            this.file_id22 = res.data.file_id
            this.loading.close();
            this.audioSrc = res.data.url
            this.$nextTick(() => {
              this.shitingplayState = 2
              const audio = this.$refs.audioPlayer2
              audio.load()
              audio.play()
            })
          } else if (res.data.status == 4) {
            if (this.timeoutId) {
              clearInterval(this.timeoutId)
            }
            this.loading.close();
            this.$message.error('声音合成失败，请重新尝试')
          }
        }).catch(error => {
          if (this.timeoutId) {
            clearInterval(this.timeoutId)
          }
          this.loading.close();
          this.$message.error(error.msg)
        })
      },
      // 不试听直接生成版
      getAuditionList2() {
        getAudition({job_id: this.job_id}).then(res => {
          if (res.data.status == 3) {
            if (this.timeoutId) {
              clearInterval(this.timeoutId)
            }
            this.sucessVoiceUrl22 = res.data.url
            this.file_id22 = res.data.file_id
            setTimeout(() => {
              postWorks({
                voice_id: this.file_id22,
                name: this.name || '未命名',
                video_id: this.chooseVideoId,
                api: this.api
              }).then(res => {
                this.loading.close();
                if (res.code == 0) {
                  this.$alert('视频创作需要一些时间，您可以在视频创作页面查看最新状态', '提交成功', {
                    confirmButtonText: '确定',
                    callback: action => {
                      this.fileList = []
                      this.$router.push('/works')
                    }
                  });
                } else {
                  this.file_id22 = ''
                  // this.inputTaici = ''
                  // this.taici = ''
                  this.sucessVoiceUrl22 = ''
                  this.$message.error(res.msg)
                }
              })
            }, 500)
          } else if (res.data.status == 4) {
            if (this.timeoutId) {
              clearInterval(this.timeoutId)
            }
            this.loading.close();
            this.$message.error('声音合成失败，请重新尝试')
          }
        }).catch(error => {
          if (this.timeoutId) {
            clearInterval(this.timeoutId)
          }
          this.loading.close();
          this.$message.error(error.msg)
        })
      },
      // 选中试听版本
      getAuditionList3() {
        getAudition({job_id: this.job_id}).then(res => {
          if (res.data.status == 3) {
            if (this.timeoutId) {
              clearInterval(this.timeoutId)
            }
            this.loading.close();
            this.audioSrc = res.data.url
            this.shitingplayState = 2
            this.$nextTick(() => {
              const audio = this.$refs.audioPlayer2
              audio.load()
              audio.play()
            })
          } else if (res.data.status == 4) {
            if (this.timeoutId) {
              clearInterval(this.timeoutId)
            }
            this.loading.close();
            this.$message.error('声音合成失败，请重新尝试')
          }
        }).catch(error => {
          if (this.timeoutId) {
            clearInterval(this.timeoutId)
          }
          this.loading.close();
          this.$message.error(error.msg)
        })
      },

      uploadTextRecord() {

        this.loading = this.$loading({
          lock: true,
          text: '合成中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });

        var selectedLanguage = ''
        if (this.languageId.length > 0) {
          if (this.languageId.length == 1) {
            selectedLanguage = this.languageId[0]
          }
          if (this.languageId.length == 2) {
            selectedLanguage = this.languageId[1]
          }
        }
        // 区分数字人id还是素材库里面的id
        // video_id: this.chooseVideoId,

        const obj = {
          language: selectedLanguage,
          emotion: this.emotionId,
          text: this.taici,
          name: this.name || '未命名',
          rate: this.tabId == 0 ? this.rate : '',
          volume: this.tabId == 0 ? this.volume : '',
          pitch: this.tabId == 0 ? this.pitch : '',
          user_voice_id: this.chooseVoiceId,
          api: this.api,
          video_channel_name: this.video_channel_name ? this.video_channel_name : ''
        }
        if (this.source) {
          obj.material_video_id = this.chooseVideoId
        } else {
          obj.video_id = this.chooseVideoId
        }
        postWorks({
          ...obj
        }).then(res => {
          if (res.code == 0) {
            this.loading.close();
            this.$alert('视频创作需要一些时间，您可以在视频创作页面查看最新状态', '提交成功', {
              confirmButtonText: '确定',
              callback: action => {
                this.fileList = []
                this.$router.push('/works')
              }
            });
          } else {
            this.loading.close();
            this.file_id22 = ''
            // this.inputTaici = ''
            // this.taici = ''
            this.sucessVoiceUrl22 = ''
            this.$message.error(res.msg)
          }
        }).catch(() => {
          this.loading.close();
        })


        // this.loading = this.$loading({
        //   lock: true,
        //   text: '合成中,请等待...',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.6)'
        // });
        // this.show2 = false
        // postAudition({
        //   voice_id: this.chooseVoiceId, text: this.taici,
        //   rate: this.tabId == 0 ? this.rate : '',
        //   volume: this.tabId == 0 ? this.volume : '',
        //   pitch: this.tabId == 0 ? this.pitch : ''
        // }).then(res => {
        //   if (res.data.job_id) {
        //     this.job_id = res.data.job_id
        //   }
        // }).catch(() => {
        //   this.loading.close()
        //   return false
        // }).then(() => {
        //   if (this.job_id) {
        //     this.timeoutId = null
        //     this.timeoutId = setInterval(this.getAuditionList2, 3000)
        //   }
        // })
      },
      // handleCreate: _.debounce(function (val) {
      //   // 处理点击事件
      //   this.handleCreate2(val)
      // }, 500),

      handleJLCreate: throttle(function () {
        this.handleCreate();
      }, 1000),

      handleCreate() {
        if (!this.chooseVideoId) {
          this.$message.error('请选择数字分身（视频）')
          return false
        }
        if (this.choosed == 2) {
          if (this.fileList.length <= 0) {
            this.$message.error('请上传音频文件')
          }
        }
        if (this.choosed == 1) {
          if (this.taici.length <= 0 || this.taici == '<br>') {
            this.$message.error('请输入台词')
            return false
          }
          if (!this.chooseVoiceId) {
            this.$message.error('请选择声音')
            return false
          }
        }
        this.dialogVisible2 = true
      },

      goCreate: _.debounce(function (val, name) {
        //|| val == 'ou'
        if (val == 'gj') {
          if (this.videoDuration * 1 < 30 || this.videoDuration * 1 > 300) {
            this.$message.error('此通道训练要求视频时长在30秒-300秒之间')
            return false
          }
        }
        this.dialogVisible2 = false
        // 处理点击事件
        this.handleCreate2(val, name)
      }, 500),

      // 最终生成
      handleCreate2(val, name) {
        this.video_channel_name = name
        this.api = val
        if (!this.chooseVideoId) {
          this.$message.error('请选择数字分身（视频）')
          return false
        }
        // 音频传
        if (this.choosed == 2) {
          if (this.fileList.length > 0) {
            this.loading = this.$loading({
              lock: true,
              text: '合成中,请等待...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.6)'
            });
            //voice_id: this.file_id22,
            // video_id: this.chooseVideoId,

            const obj = {
              name: this.name || '未命名',
              api: this.api,
              video_channel_name: this.video_channel_name ? this.video_channel_name : ''
            }
            if (this.audio_source) {
              obj.material_audio_id = this.fileList[0].id
            } else {
              obj.voice_id = this.fileList[0].file_id
            }
            if (this.source) {
              obj.material_video_id = this.chooseVideoId
            } else {
              obj.video_id = this.chooseVideoId
            }
            postWorks({
              ...obj
            }).then(res => {
              if (res.code == 0) {
                this.loading.close();
                this.$alert('视频创作需要一些时间，您可以在视频创作页面查看最新状态', '提交成功', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.fileList = []
                    this.$router.push('/works')
                  }
                });
              } else {
                this.loading.close();
                this.fileList = []
                this.$message.error(res.msg)
              }
            }).catch(() => {
              this.loading.close();
            })
          } else {
            this.$message.error('请上传音频文件')
          }
        }
        // 文本传
        if (this.choosed == 1) {
          if (this.taici.length <= 0) {
            this.$message.error('请输入台词')
            return false
          }
          if (!this.chooseVoiceId) {
            this.$message.error('请选择声音')
            return false
          }
          if (this.file_id22 && this.sucessVoiceUrl22) {
            this.loading = this.$loading({
              lock: true,
              text: '合成中,请等待...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.6)'
            });
            const obj = {
              name: this.name || '未命名',
              api: this.api,
              video_channel_name: this.video_channel_name ? this.video_channel_name : '',
              voice_id: this.file_id22,
            }
            if (this.source) {
              obj.material_video_id = this.chooseVideoId
            } else {
              obj.video_id = this.chooseVideoId
            }
            postWorks({
              ...obj
            }).then(res => {
              if (res.code == 0) {
                this.loading.close();
                this.$alert('视频创作需要一些时间，您可以在视频创作页面查看最新状态', '提交成功', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.fileList = []
                    this.$router.push('/works')
                  }
                });
              } else {
                this.loading.close();
                this.file_id22 = ''
                // this.inputTaici = ''
                // this.taici = ''
                this.sucessVoiceUrl22 = ''
                this.$message.error(res.msg)
              }
            }).catch(() => {
              this.loading.close();
            })
          } else {
            this.uploadTextRecord()
          }
        }
        this.$store.dispatch('updatePoints')
      },

      handleJump(val, path) {
        localStorage.setItem('navId', val)
        this.$router.push(path)
      },
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
      this.$nextTick(() => {
        const video = this.$refs.videoPlayer;
        if (video) {
          video.addEventListener('loadedmetadata', () => {
            this.videoDuration = video.duration.toFixed(0);
          });
        }
      });
    },
  }
</script>

<style lang="scss" scoped>
  .create-box-index {
    font-size: 18px;

    p {
      margin: 0;
      padding: 0;
    }
  }

  .left-create-box::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .left-create-box {
    width: 556px;
    /*height: 1023px;*/
    /*background: #0D1027;*/
    border-right: 1px rgba(250, 250, 250, 0.1) solid;
    height: calc(100vh - 50px);
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;

    .part1-box {
      padding: 0 32px 27px 32px;
    }

    .select-box {
      /*height: 80px;*/
      width: 100%;
      position: sticky;
      top: 0;
      z-index: 999;
      /*background: #0D1027;*/

      .pp1 {
        font-weight: 500;
        line-height: 60px;
        font-size: 16px;
        color: #EEEEEE;
        margin-right: 16px;
      }

      .pp1-active {
        color: #01FBF5 !important;
      }

      .hs-box {
        width: 90px;
        height: 28px;
        background: #0E1126;
        border-radius: 6px;
        border: 1px solid rgba(255, 255, 255, 0.15);

        .normal {
          width: 44px;
          height: 24px;
          border-radius: 4px;
          text-align: center;
          font-weight: 400;
          font-size: 12px;
          color: #FAFAFAAA;
          line-height: 24px;
        }

        .hs-active {
          background: #6C14FF;
          border-radius: 4px;
          color: #ffffff;
        }
      }
    }

    .all-video-y::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }

    .all-video-y {
      width: 100%;
      max-height: 350px;
      overflow-y: scroll;
      overflow-x: hidden;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer 10+ */
    }

    .all-every-me-fs {
      margin-right: 23px;
    }

    .every-me-fs {
      width: 105px;
      height: 140px;
      /*background-size: 100% 100%;*/
      border-radius: 8px;
      background-size: cover;
      background-position: center;
    }

    .fs-border {
      text-align: center;
      border: 1px #1f2237 solid;

      img {
        width: 28px;
        height: 28px;
        margin-bottom: 10px;
      }

      font-size: 12px;
    }

    .all-every-me-fs:nth-child(4n) {
      margin-right: 0;
    }

    .every-me-text {
      width: 105px;
      height: 40px;
      font-weight: 400;
      font-size: 14px;
      color: #FAFAFAAA;
      line-height: 40px;
    }

    .all-every-me-fs-h {
      margin-right: 23px;
    }

    .every-me-fs-h {
      width: 230px;
      height: 140px;
      background-size: 100% 100%;
      border-radius: 8px;
    }

    .all-every-me-fs-h:nth-child(2n) {
      margin-right: 0;
    }

    .every-me-text-h {
      width: 230px;
      height: 40px;
      font-weight: 400;
      font-size: 14px;
      color: #FAFAFAAA;
      line-height: 40px;
    }

    .actived {
      position: relative;
    }

    .actived::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: url("../assets/pcImages/2.1_Icon_Choose@2x.png") no-repeat;
      background-size: 100% 100%;
      z-index: 9;
    }

    .actived-h {
      position: relative;
    }

    .actived-h::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: url("../assets/pcImages/2.1_Icon_Choose3@2x.png") no-repeat;
      background-size: 100% 100%;
      z-index: 9;
    }

    .voice-tj-box {
      padding: 17px 32px 20px 32px;
      border-top: 1px solid;
      border-bottom: 1px solid;
      /*rgba(250, 250, 250, 0.1)*/
      .text1 {
        font-weight: 500;
        font-size: 16px;
        color: #FAFAFA;
        margin-bottom: 15px;
      }

      .btn11, .btn22 {
        /*width: 90px;*/
        padding: 0 14px;
        height: 28px;
        /*background: #0E1126;*/
        border-radius: 6px;
        /*border: 1px solid rgba(255, 255, 255, 0.15);*/

        font-weight: 400;
        font-size: 12px;
        color: #EEEEEEAA;
        margin-bottom: 15px;

        img {
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
      }

      .shezhi-box {
        padding: 20px 24px;
        width: 492px;
        height: 128px;
        /*background: #1F2237;*/
        border-radius: 8px;

        font-weight: 500;
        font-size: 12px;
        color: #FAFAFA;

        .part-slider {
          height: 28px;
        }
      }
    }

    .all-voice-choose-box {
      padding: 20px 32px;

      .voice-choose-box::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }

      .voice-choose-box {
        width: 100%;
        max-height: 310px;
        overflow-y: scroll;
        overflow-x: hidden;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* Internet Explorer 10+ */
      }

      .every-voice {
        margin-bottom: 12px;
        padding: 16px 14px;

        width: 238px;
        height: 80px;
        /*background: #24273C;*/
        border-radius: 8px;
        border: 1px solid;


        .card-img {
          position: relative;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          margin-right: 16px;

          img {
            width: 100%;
            height: 100%;
            object-fit: fill;
            border-radius: 50%;
          }

          .hover-box {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            text-align: center;
            background: rgba(0, 0, 0, .5);
            border-radius: 50%;
            cursor: pointer;
            justify-content: center;
            align-items: center;

            .play-pause-btn {
              margin-top: 10px;

              .playing-box {
                width: 30px;
                height: 18px;
              }
            }
          }
        }

        .pp4 {
          width: 145px;
          font-weight: 400;
          font-size: 16px;
          color: #FAFAFA;
          text-align: left;
          margin-bottom: 4px;
        }

        .pp5 {
          font-weight: 400;
          font-size: 12px;
          color: #FAFAFAAA;
          text-align: left;
        }

        .all-tags {
          .every-tag {
            font-size: 12px;
            color: #5b647a;
            letter-spacing: 0;
            text-align: center;
            line-height: 20px;
            font-weight: 400;
            background: #edeef7;
            border-radius: 4px;
            padding: 0 4px;
            white-space: nowrap;
            margin-right: 5px;
          }
        }
      }

      .every-tab {
        font-weight: 400;
        font-size: 16px;
        color: #FAFAFAAA;
        text-align: left;
        margin-right: 20px;
      }

      .activeTab {
        color: #01FBF5 !important;
      }


      .active {
        position: relative;
      }

      .active::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        background: url("../assets/pcImages/2.1_Icon_Choose2@2x.png") no-repeat;
        background-size: 100% 100%;
        z-index: 0;
        left: 0;
        top: 0;
      }


      img {
        width: 44px;
        height: 44px;
      }
    }


  }

  .right-create-box::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .right-create-box {
    position: relative;
    padding: 20px 32px 20px;
    box-shadow: 0 4px 12px 4px #0000000d;
    height: calc(100vh - 50px);
    width: 1160px;
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    border-radius: 12px;

    .name-box {
      width: 100%;

      .pp2 {
        font-weight: 500;
        font-size: 16px;
        color: #FAFAFA;
        text-align: left;
      }
    }

    .video-show-box {
      width: 1120px;
      height: 380px;
      /*background: url("../assets/pcImages/2.1_Video_Bg@2x.png") no-repeat;*/
      background-size: 100% 100%;
      margin: 20px auto;

      .part-video {
        width: 279px;
        height: 380px;
        display: block;
        margin: 0 auto
      }
    }

    .choose-box {
      width: 452px;
      height: 40px;
      /*background: #35383E;*/
      border-radius: 6px;

      img {
        width: 16px;
        height: 16px;
        display: block;
        margin-right: 4px;
      }

      .wb-text-box, .yp-text-box {
        width: 50%;

        font-weight: 500;
        font-size: 14px;
        /*color: #FFFFFF;*/

        text-align: center;
        line-height: 40px;
        height: 40px;
        border-radius: 8px;
      }

      .active {
        margin: 0 4px;
        height: 32px;
        line-height: 32px;
        /*background: #6C14FF;*/
        border-radius: 4px;
      }
    }

    .taici-box {
      .inputText1::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }

      .inputText1 {
        font-size: 14px;
        width: 100%;
        height: 220px;
        padding: 10px 15px;
        background: #1f2237;
        color: #fff;
        border-radius: 4px;
        overflow-y: scroll;
        -ms-overflow-style: none; /* 对于IE和Edge */
        scrollbar-width: none; /* 对于FireFox */
        .editBox {
          width: 100%;
          height: 100%;
        }
      }

      .inputText2::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }

      .inputText2 {
        font-size: 14px;
        width: 100%;
        height: 220px;
        padding: 10px 15px;
        background: #ffffff;
        color: #333333;
        border: 1px solid rgb(220, 220, 220);
        border-radius: 4px;
        overflow-y: scroll;
        -ms-overflow-style: none; /* 对于IE和Edge */
        scrollbar-width: none; /* 对于FireFox */
        .editBox {
          width: 100%;
          height: 100%;
        }
      }

      .editBox-tips {
        background: #1f2237;
        color: #ffffffAA;
        font-size: 12px;
        padding: 7.5px 15px;
      }

      .editBox2-tips {
        background: #ffffff;
        color: #333333;
        border: 1px solid rgb(220, 220, 220);
        border-top: 0;
        font-size: 12px;
        padding: 7.5px 15px;
      }

      .st-part {
        img {
          width: 16px;
          height: 16px;
        }

        /*width: 88px;*/
        padding: 0 14px;
        height: 28px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.15);

        font-weight: 500;
        font-size: 12px;
        color: #FFFFFFAA;
      }
    }

    .shezhi-box {
      width: 320px;
      height: 160px;
      padding: 5px 20px;
    }

    .video-box {
      .pp3 {
        margin: 15px 0 10px;
        padding: 8px 0px;
        font-size: 16px;
        font-weight: 700;
      }

      .every-tab {
        font-size: 18px;
        width: 50px;
        text-align: center;
        margin-right: 30px;
        padding-bottom: 10px;
      }

      .activeTab {
        font-weight: 700;
        color: #7559ff;
        border-bottom: 2px solid #7559ff;
      }

      .every-video {
        cursor: pointer;
        width: calc(25% - 12px);
        height: 56px;
        background: #f4f5f7;
        border: 1px solid transparent;
        gap: 8px;
        border-radius: 5px;
        padding: 0 12px;
        margin: 0 10px 15px 0;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .active {
        /*position: relative;*/
        border: 1px solid #7559ff;
        /*.choosed-box{*/
        /*  position: absolute;*/
        /*  right: 0;*/
        /*  bottom: 0;*/
        /*  font-size: 8px;*/
        /*  color: #fff;*/
        /*  border-style: solid;*/
        /*  border-top: 8px solid transparent;*/
        /*  border-right: 10px solid #7559ff;*/
        /*  border-bottom: 8px solid #7559ff;*/
        /*  border-left: 10px solid transparent;*/
        /*  img{*/
        /*    display: block;*/
        /*    width: 12px;*/
        /*    height: 12px;*/
        /*  }*/
        /*}*/
      }

      .voice-choose-box {
        height: calc(100vh - 95px - 50px - 580px);
        overflow-y: scroll;
      }
    }

    .warning {
      padding: 12px 0 12px 16px;
      margin-top: 24px;
      font-size: 14px;
      color: #fff;
      background: #24273C;
      line-height: 20px;
      border-radius: 8px;

      .pp4 {
        font-weight: 700;
        margin-bottom: 5px;
      }

      .pp5 {
        width: 250px;
        text-align: left;

        span {
          opacity: 0.7;
        }
      }
    }

    .upload-wanchen-box {
      height: 200px;
      margin-top: 24px;
      font-size: 14px;
      color: #fff;
      background: #24273C;
      border-radius: 8px;
    }

    .btn-box {
      margin-top: 20px;
      /*position: absolute;*/
      /*bottom: 30px;*/
      /*right: 30px;*/
      /*width: 100%;*/
      /*height: 40px;*/
      /*box-sizing: border-box;*/


      /*.btn1, .btn2 {*/
      /*  cursor: pointer;*/
      /*  text-align: center;*/
      /*  color: #fff;*/
      /*  background-color: #7559ff;*/
      /*  box-shadow: 0 2px 0 rgba(88, 5, 255, 0.06);*/
      /*  line-height: 40px;*/
      /*  border-radius: 8px;*/
      /*}*/

      .btn1 {
        width: 475px;
        height: 40px;
      }

      .btn2 {
        width: 200px;
        height: 48px;
        background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
        border-radius: 8px;

        font-weight: 600;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 45px;
        text-align: center;
      }

    }
  }

  .all-js-box {
    .scroll-box {
      /*overflow-y: hidden;*/
      /*overflow-x: scroll;*/
      width: 100%;
      /*scrollbar-width: none; !* Firefox *!*/
      /*-ms-overflow-style: none;*/
    }

    .erery-js {
      /*font-size: 16px;*/
      flex-shrink: 0;
      height: 32px;
      padding: 0 12px;
      color: #0E1126;
      // background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
      border-radius: 24px;
      line-height: 32px;
      margin: 5px 12px 5px 0;
      border: 1px solid rgba(0, 0, 0, 0.15);
    }

    .active {
      background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
      border: 0;
      color: #FFFFFF;
    }
  }

  .part1-box {
    .pp-fw {
      text-decoration: underline;
      color: #409EFF;
    }
  }

  .ai-choose-box {
    .ai-part1-box {
      width: 240px;
      height: 190px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px rgba(151, 151, 151, 0.5) dashed;
      padding-top: 40px;
      margin-bottom: 20px;
      position: relative;
      margin-right: 20px;

      .aipp1 {
        font-weight: 500;
        font-size: 16px;
        color: #222222;
        text-align: center;
        margin-bottom: 4px;
      }

      .aipp2 {
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        text-align: center;
        margin-bottom: 8px;
      }

      .aipp3 {
        position: absolute;
        padding: 0 14px;
        height: 20px;
        background: #67F4F1;
        border-radius: 4px;
        right: 0;
        top: 0;

        font-weight: 400;
        font-size: 12px;
        color: #333333;
        line-height: 20px;
        text-align: center;
      }

      .aipp4 {
        img {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }

        font-weight: 400;
        font-size: 12px;
        color: #AA8242;
        margin-bottom: 30px;
      }

      .no-credits-text {
        height: 46px;
      }

      .aibtn1, .aibtn2, .aibtn3 {
        width: 216px;
        height: 36px;
        background: #6C14FF;
        border-radius: 4px;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 36px;
        text-align: center;
        margin: 0 auto;
      }

      .aibtn2 {
        background: #EADDAD;
        color: #604E10;
      }

      .aibtn3 {
        background: #67F4F1;
        color: #26415A;
      }
    }

    .ai-part1-box:first-child {

    }

    .ai-part1-box:nth-child(2n) {
      .aibtn1 {
        background: #EADDAD;
        color: #604E10;
      }
    }

    .ai-part1-box:nth-child(3n) {
      .aibtn1 {
        background: #67F4F1;
        color: #26415A;
      }
    }

    .ai-part1-box:nth-child(4n) {
      margin-right: 0;

      .aibtn1 {
        background: rgb(142, 176, 83);
        color: #fff;
      }
    }

  }
</style>
<style>
  .create-box-index .upload-box .el-upload {
    width: 100%;
  }

  .create-box-index .upload-box1 .el-upload-dragger {
    background: #24273C;
  }

  .create-box-index .upload-box .el-upload .el-upload-dragger {
    width: 100% !important;
  }

  .create-box-index .inputText1 .el-textarea__inner {
    background: #1F2237;
    color: #FFFFFF
  }

  .create-box-index .inputText1 .el-input__count {
    background: #1F2237;
    color: #FFFFFF
  }

  .taici-box .el-cascader .el-input .el-input__inner {
    background: rgb(53, 56, 62);
    border: 1px solid rgb(53, 56, 62);
    color: #ffffff;
  }

  .taici-box .el-select .el-input .el-input__inner {
    background: rgb(53, 56, 62);
    border: 1px solid rgb(53, 56, 62);
    color: #ffffff;
  }

</style>



// WEBPACK FOOTER //
// src/components/create.vue